import dayjs from "dayjs";

export const PREPAYMENT_EDITABLE_STATUS = "awaiting_authorisation";

export const canEditPrepayment = prepayment =>
  prepayment?.status?.id === PREPAYMENT_EDITABLE_STATUS;

export function mapPrepaymentToRecordPaymentInitialValues(prepayment) {
  if (!prepayment) return {};

  const poOutstandingById = {};
  prepayment.allocations?.forEach(row => {
    const poId = row.purchase_order?.id;
    if (!poId) return;
    const allocated = Number(row.allocated_amount ?? 0);
    poOutstandingById[poId] = Number.isFinite(allocated) ? allocated : 0;
  });

  return {
    supplier_id: prepayment.supplier?.id ?? "",
    account_id: prepayment.account?.id ?? "",
    reference: prepayment.reference ?? "",
    date_paid: prepayment.date_paid ? dayjs(prepayment.date_paid) : dayjs(),
    currency_id: prepayment.currency?.id ?? "",
    amount: prepayment.amount ?? "",
    bank_account_dummy_id:
      prepayment.bank_account_dummy?.id ?? prepayment.bank_account_dummy ?? "",
    payment_type_id: prepayment.payment_type?.id ?? prepayment.payment_type ?? "deposit",
    poOutstandingById,
    allocations:
      prepayment.allocations?.length > 0
        ? prepayment.allocations.map(row => ({
            purchase_order_id: row.purchase_order?.id ?? "",
            allocated_amount: row.allocated_amount ?? "",
          }))
        : [{ purchase_order_id: "", allocated_amount: "" }],
  };
}
